"use client";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  todaysSale: 0,
  todaysTotalKg: 0,
  allSalesAmoumt: 0,
  allTotalKg: 0,
};

const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {
    setTodaysSale(state, action) {
      state.todaysSale = action.payload.reduce(
        (accum, cur) => accum + cur.total_sales,
        0
      );
      state.todaysTotalKg = action.payload.reduce(
        (accum, cur) => accum + cur.total_kg_sold,
        0
      );
    },

    setAllSalesAmount(state, action) {
      state.allSalesAmoumt = action.payload.reduce(
        (accum, cur) => accum + cur.total_sales,
        0
      );
      state.allTotalKg = action.payload.reduce(
        (accum, cur) => accum + cur.total_kg_sold,
        0
      );
    },

    resetSales(state, action) {
      return initialState;
    },
  },
});

export const { setTodaysSale, setAllSalesAmount, resetSales } =
  saleSlice.actions;

export default saleSlice.reducer;
